'use strict';

/**
 * Updates get started widget closed position based on panel width.
 * @returns {void}
 */
function updateGetStartedPanelOffset() {
    $('.get-started-widget').each(function () {
        var $widget = $(this);
        var panelWidth = $widget.find('.get-started-panel').outerWidth();

        $widget.css('--panel-offset', panelWidth + 'px').removeClass('d-lg-none').addClass('d-lg-flex');
    });
}

var previousWidth = $(window).width();

// Initial desktop load
if (previousWidth >= 1024) {
    updateGetStartedPanelOffset();
    $('.get-started-widget').removeClass('is-open');
}

$(window).on('resize', function () {
    var currentWidth = $(window).width();

    // Mobile -> Desktop
    if (previousWidth < 1024 && currentWidth >= 1024) {
        $('.get-started-widget').removeClass('d-lg-flex').addClass('d-none');
        var wasModalOpen = $('#get-started-modal').hasClass('show');

        $('#get-started-modal').modal('hide');

        updateGetStartedPanelOffset();

        if (wasModalOpen) {
            $('.get-started-tab').trigger('click');
        }
    }

    // Desktop -> Mobile
    if (previousWidth >= 1024 && currentWidth < 1024) {
        $('.get-started-widget').removeClass('d-none');
        var wasWidgetOpen = $('.get-started-widget').hasClass('is-open');

        if (wasWidgetOpen) {
            $('.get-started-widget').removeClass('is-open');
            $('#get-started-modal').modal('show');
        }
    }

    previousWidth = currentWidth;
});

$('body').on('click', '.get-started-tab', function () {
    if ($(window).width() < 1024) {
        $('#get-started-modal').modal('show');

        return;
    }

    var $widget = $(this).closest('.get-started-widget');

    updateGetStartedPanelOffset();

    var isOpen = $widget.toggleClass('is-open').hasClass('is-open');

    $(this).attr('aria-expanded', isOpen);
});
